// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2OZk8","sendOtp":"AuthorizeToLogin_sendOtp__1bMBX"};